export default __webpack_public_path__ + "static/media/can-do.85f5a3fc.png";